module.exports = __webpack_public_path__ + "static/our-company-00f91ba1fb75130622047109eea88de3.png";